import {Injectable, inject, ApplicationRef} from '@angular/core';
import {SwUpdate} from '@angular/service-worker';
import {concatMap, interval, first, filter} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  private swUpdate = inject(SwUpdate);
  private appRef = inject(ApplicationRef);

  constructor() {
    if (!this.swUpdate.isEnabled) return;
    this.inicializarEscuchaDeActualizaciones();
    this.configurarComprobacionPeriodica()
  }

  private inicializarEscuchaDeActualizaciones() {
    this.swUpdate.versionUpdates.subscribe((evt) => {
      switch (evt.type) {
        case 'VERSION_READY':
          console.warn(`Nueva versión detectada en el servidor. Forzando activación...`);
          this.swUpdate.activateUpdate().then(() => {
            window.location.reload();
          });
          break;
        case 'VERSION_INSTALLATION_FAILED':
          console.error(`Error al instalar la nueva versión: ${evt.error}`);
          break
      }
    })
  }

  private configurarComprobacionPeriodica() {
    this.appRef.isStable.pipe(
      filter((stable) => stable),
      first(),
      concatMap(() => interval(60 * 60 * 1000))
    ).subscribe(() => {
      this.swUpdate.checkForUpdate()
        .catch(err => console.error('Error buscando actualizaciones:', err))
    })
  }
}